import { ArrangeAppliers } from 'rete-auto-arrange-plugin';
import type { Schemes } from './plugins';

export async function layoutGraph(
  editor: any,
  arrange: any,
  taskNodes: Map<number, any>,
  area: any,
  sendNodePosition: (taskId: number, position: { x: number; y: number }) => void
) {
  try {
    const nodes = editor.getNodes();
    if (nodes.length === 0) {
      return;
    }

    const applier = new ArrangeAppliers.TransitionApplier<Schemes, never>({
      duration: 250,
    });

    await arrange.layout({ applier });

    Array.from(taskNodes.values()).forEach((node) => {
      const position = area.nodeViews.get(node.id)?.position;
      const apiId = (node as any).apiId;
      if (apiId && position) {
        sendNodePosition(apiId, position);
      }
    });
  } catch (error) {
    console.error('Layout failed:', error);
  }
}
